<template>
  <div 
    v-on-clickaway="hidesidemenu"
    class="sidemenuwrapper">

    <a href="" class="backbtn" @click.prevent="$emit('update:menuopen', false)">
        <b-icon icon="chevron-left" /> Back
    </a>
    
    <div class="userprofile">

        <template v-if="user && user.avatar_url">
                <div 
                class="userimage" 
                :style="`background-image:url(${user.avatar_url});`">
            </div>
        </template>

        <template v-else>
            <div class="userimage">
                <b-icon icon="person-circle"></b-icon>
            </div>
        </template>
        
        <div class="userinfo">
            <div @click="$router.push({name : 'profile'}), $emit('update:menuopen', false)" class="name">{{user ? user.name : ''}} <b-icon icon="pencil"></b-icon></div>
            <a href="" @click.prevent="logout">Logout</a>
        </div>
    </div>
    <b-list-group v-if="user">
        <b-list-group-item 
            href="" 
            :class="[{'active' : $route.name == 'deliveries' || $route.name == 'employeeDeliveries'}]"
            @click.prevent="$router.push({name : 'deliveries'}), $emit('update:menuopen', false)">
            <b-icon icon="truck"></b-icon> 
            Orders
        </b-list-group-item>

        <template v-if="user.roles.includes('super-admin')">
            <b-list-group-item 
                :class="[{'active' : $route.name == 'boxes'}]"
                href="" 
                @click.prevent="$router.push({name : 'boxes'}), $emit('update:menuopen', false)">
                <b-icon icon="inboxes"></b-icon> 
                Boxes
            </b-list-group-item>

            <b-list-group-item 
                :class="[{'active' : $route.name == 'flavors'}]"
                href="" 
                @click.prevent="$router.push({name : 'flavors'}), $emit('update:menuopen', false)">
                <b-icon icon="heart"></b-icon> 
                Flavors
            </b-list-group-item>
            
            <b-list-group-item 
                 :class="[{'active' : $route.name == 'settings'}]"
                href="" 
                @click.prevent="$router.push({name : 'settings'}), $emit('update:menuopen', false)">
                <b-icon icon="gear"></b-icon> 
                Settings
            </b-list-group-item>
           
        </template>

        <template v-if="user.roles.includes('super-admin') || user.roles.includes('manager')">
             <b-list-group-item 
                 :class="[{'active' : $route.name == 'employee'}]"
                href="" 
                @click.prevent="$router.push({name : 'employee'}), $emit('update:menuopen', false)">
                <b-icon icon="people"></b-icon> 
                Employees
            </b-list-group-item>
        </template>
    </b-list-group>
  </div>
</template>

<script>
//Helpers
import Helper from '@/helpers/helper'

// plugins
import axios from 'axios'

// Directives
import { directive as onClickaway } from 'vue-clickaway';

export default {
    props : {
        /**
         * Side menu state
         */
        menuopen : {
            type   : Boolean,
            default: () => {
                return false;
            }
        }
    },  
    directives: {
        onClickaway: onClickaway,
    },
    computed : {
        /**
         * Logged In user
         */
        user() {
            return this.$store.state.user
        }
    },
    methods : {
        /**
         * Logout account
         * delete session cookie
         */
        async logout() {
            this.$emit('update:menuopen', false)
            await Helper.deleteCookie('holeswebtoken');
            await axios.post('/logout');
            this.$router.push({name : 'login'});
        },
        /**
         * Hide side menu when clicked outside of the side menu
         * but add header profile button to the exemption
         */
        hidesidemenu(e) {
            const paths = Array.from(e.path);
            const profile  = paths.map(p => p.dataset).find(d => d ? d.clickaway == 'profile' : null);
            if(!profile) {
                this.$emit('update:menuopen', false);
            }
        }
    }
}
</script>

<style lang="scss">
@import '@/scss/partials/_colors.scss';
@import '@/scss/partials/_mixins.scss';

.sidemenuwrapper {
    height          : 100vh;
    position        : fixed;
    top             : 0;
    right           : 0;
    width           : 100vw;
    background-color: #fff;
    z-index         : 600;
    border-left     : 1px solid $lightgrey;

    @include screen-min(lg) {
        width : 220px;
    }
   

    .backbtn {
        display      : block;
        margin-top   : 15px;
        margin-bottom: 15px;
        padding-left : 15px;

        @include screen-min(lg) {
            display: none;
        }
    }


    .list-group {
        // width: 100vw;

        .list-group-item {
            cursor: pointer;
            border: none;

            svg {
                margin-right : 10px;
            }

            &:hover, &.active {
                background-color: $primaryColor;
                color           : white;
            }
        }
    }

    .userprofile {
        display: flex;
        padding: 15px;

        .userinfo {
            cursor: pointer;

            &:hover {
                color : $primaryColor;
            }

            .b-icon.bi {
                font-size  : 12px;
                color      : $primaryColor;
                margin-left: 10px;
                position   : relative;
                top        : -2px;
            }
        }

        .userimage {
            width          : 30px;
            height         : 30px;
            flex           : 0 0 30px;
            border-radius  : 100%;
            background-size: cover;
            margin-right   : 10px;
            font-size      : 25px;
            display        : flex;
            align-items    : center;
            justify-content: center;
            color          : $grey;
        }

        a {
            font-size: 15px;
            color    : $primaryColor;
        }
    }
}
</style>